import type { Card } from '@/types/entities'

/**
 * The teams a work item belongs to, reading either shape.
 *
 * Mirrors `teamIdsOf` in the backend. Rows written before the list column carry only the
 * singular `teamId` and there is no migration, so every reader has to accept both — having
 * one function answer it is what stops a component forgetting.
 */
export const teamIdsOf = (card: Pick<Card, 'teamId' | 'teamIds'>): string[] =>
  card.teamIds && card.teamIds.length > 0 ? card.teamIds : card.teamId ? [card.teamId] : []
